import { multiselectStyles as foundationMultiselectStyles } from '@genesislcap/foundation-ui';
import { css } from '@microsoft/fast-element';
import { defaultRapidBGColor, defaultRapidLabelColor } from '../_common';
import { PrimaryRapidColorHEX } from '../_common';
export const multiselectStyles = css `
  ${foundationMultiselectStyles}

  :host {
    --primary-gradient-angle: -113.5deg;
  }

  #display-field {
    background: ${defaultRapidBGColor};
  }

  #display-field:focus {
    outline: none;
    background:
      linear-gradient(
          var(--primary-gradient-angle),
          ${PrimaryRapidColorHEX.blue} 0%,
          ${PrimaryRapidColorHEX.purple} 100%
        )
        top/100% 1px,
      linear-gradient(
          var(--primary-gradient-angle),
          ${PrimaryRapidColorHEX.blue} 0%,
          ${PrimaryRapidColorHEX.purple} 100%
        )
        bottom/100% 1px;
    background-origin: border-box;
    background-repeat: no-repeat;
    border: 1px solid transparent;
    border-right-color: ${PrimaryRapidColorHEX.blue};
    border-left-color: ${PrimaryRapidColorHEX.purple};
  }

  ::slotted(zero-checkbox),
  zero-checkbox {
    border-bottom: 1px solid rgb(46 48 52);
    padding: 5px 0 5px 5px;
    margin: 0;
  }

  ::slotted(zero-checkbox:hover),
  zero-checkbox:hover {
    background-color: rgb(45 47 51);
    cursor: pointer;
  }

  ::slotted(zero-checkbox)::part(label),
  zero-checkbox::part(label) {
    overflow-x: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .label {
    color: ${defaultRapidLabelColor};
  }
`;
